import React from 'react';
import { AuthFlow } from '../../components';
import FlowHandlerProvider from '../../contexts/FlowHandlerProvider';
const CorbadoAuth = ({ onLoggedIn, handleNavigationEvents, initialBlock, initialAutoFocus = true, }) => {
    return (React.createElement(FlowHandlerProvider, { onLoggedIn: onLoggedIn, handleNavigationEvents: handleNavigationEvents, initialBlock: initialBlock },
        React.createElement(AuthFlow, { initialAutoFocus: initialAutoFocus })));
};
export default CorbadoAuth;
